import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SmartpassLogoComponent } from '../smartpass-logo/smartpass-logo.component';
import { DisplayCardComponent } from '../display-card/display-card.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PinnableComponent } from '../pinnable/pinnable.component';
import { TraveltypePickerComponent } from '../traveltype-picker/traveltype-picker.component';
import { SPSearchComponent } from '../sp-search/sp-search.component';
import { PassCollectionComponent } from '../pass-collection/pass-collection.component';
import { PassCellComponent } from '../pass-cell/pass-cell.component';
import { RestrictionDummyComponent } from '../admin/restriction-dummy/restriction-dummy.component';
import { BackButtonComponent } from '../admin/back-button/back-button.component';
import { PassCardComponent } from '../pass-card/pass-card.component';
import { TravelViewComponent } from '../travel-view/travel-view.component';
import { DurationPickerComponent } from '../duration-picker/duration-picker.component';
import { CardButtonComponent } from '../card-button/card-button.component';
import { PagerComponent } from '../pager/pager.component';
import { RoundInputComponent } from '../admin/round-input/round-input.component';
import { DragulaModule } from 'ng2-dragula';
import { AppInputComponent } from '../app-input/app-input.component';
import { CalendarComponent } from '../admin/calendar/calendar.component';
import { SafariScrollDirective } from '../safari-scroll.directive';
import { ToggleInputComponent } from '../admin/toggle-input/toggle-input.component';
import { CalendarPickerComponent } from '../calendar-components/calendar-picker/calendar-picker.component';
import { TimePickerComponent } from '../calendar-components/time-picker/time-picker.component';
import { AdminCalendarToggleComponent } from '../calendar-components/admin-calendar-toggle/admin-calendar-toggle.component';
import { ToggleOptionsComponent } from '../calendar-components/admin-calendar-toggle/toggle-options/toggle-options.component';
import { SpChipsComponent } from '../sp-chips/sp-chips.component';
import { SWIPER_CONFIG, SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { GettingStartedProgressService } from '../admin/getting-started-progress.service';
import { CreatePassButtonComponent } from '../passes/create-pass-button/create-pass-button.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { IosCalendarWheelComponent } from '../ios-calendar/ios-calendar-wheel/ios-calendar-wheel.component';
import { IosCalendarComponent } from '../ios-calendar/ios-calendar.component';
import { NavbarElementSenderDirective } from '../core/directives/navbar-element-sender.directive';
import { ChartsModule } from 'ng2-charts';
import { ConsentMenuComponent } from '../consent-menu/consent-menu.component';
import { LoginComponent } from '../auth/login/login.component';
import { IntroDialogComponent } from '../intro-dialog/intro-dialog.component';
import { IntroComponent } from '../intro/intro.component';
import { SortMenuComponent } from '../sort-menu/sort-menu.component';
import { CoreModule } from '../core/core.module';
import { PrivacyCardComponent } from '../admin/accounts/privacy-card/privacy-card.component';
import { ProfileComponent } from '../admin/accounts/account-groups/profile/profile.component';
import { AccountGroupsComponent } from '../admin/accounts/account-groups/account-groups.component';
import { TeacherPinStudentComponent } from '../teacher-pin-student/teacher-pin-student.component';
import { ReportSuccessToastComponent } from '../report-success-toast/report-success-toast.component';
import { RestrictionPickerComponent } from '../restriction-picker/restriction-picker.component';
import { SpAppearanceComponent } from '../sp-appearance/sp-appearance.component';
import { SpLanguageComponent } from '../sp-language/sp-language.component';
import { MyProfileDialogComponent } from '../my-profile-dialog/my-profile-dialog.component';
import { ProfileInfoComponent } from '../my-profile-dialog/profile-info/profile-info.component';
import { ChangePasswordComponent } from '../my-profile-dialog/change-password/change-password.component';
import { CustomToolTipComponent } from './shared-components/custom-tool-tip/custom-tool-tip.component';
import { PassLimitTooltipComponent } from './shared-components/pass-limit-tooltip/pass-limit-tooltip.component';
import { BigStudentPassCardComponent } from '../big-student-pass-card/big-student-pass-card.component';
import { StudentMetricsComponent } from '../big-student-pass-card/student-metrics/student-metrics.component';
import { InlinePassCardComponent } from '../inline-pass-card/inline-pass-card.component';
import { RequestCardComponent } from '../request-card/request-card.component';
import { InlineRequestCardComponent } from '../inline-request-card/inline-request-card.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { SettingsDescriptionPopupComponent } from '../settings-description-popup/settings-description-popup.component';
import { AppTextareaComponent } from '../app-textarea/app-textarea.component';
import { SquareButtonComponent } from '../square-button/square-button.component';
import { RoundButtonComponent } from '../round-button/round-button.component';
import { NuxEncounterPreventionComponent } from '../nux-components/nux-encounter-prevention/nux-encounter-prevention.component';
import { SmartpassSearchComponent } from '../smartpass-search/smartpass-search.component';
import { EncounterGroupComponent } from '../admin/accounts/encounter-prevention-dialog/encounter-group/encounter-group.component';
import { SelectRoleComponent } from '../admin/accounts/select-role/select-role.component';
import { NuxTeacherViewComponent } from '../nux-components/nux-teacher-view/nux-teacher-view.component';
import { DateTimeFilterComponent } from '../admin/explore/date-time-filter/date-time-filter.component';
import { ReportInfoDialogComponent } from '../admin/explore/report-info-dialog/report-info-dialog.component';
import { StatusPopupComponent } from '../admin/profile-card-dialog/status-popup/status-popup.component';
import { EncounterPreventionDialogComponent } from '../admin/accounts/encounter-prevention-dialog/encounter-prevention-dialog.component';
import { CreateGroupComponent } from '../admin/accounts/encounter-prevention-dialog/create-group/create-group.component';
import { ReportDescriptionComponent } from '../admin/accounts/encounter-prevention-dialog/report-description/report-description.component';
import { EncounterOptionsComponent } from '../admin/accounts/encounter-prevention-dialog/encounter-options/encounter-options.component';
import { EncounterGroupDescriptionComponent } from '../admin/accounts/encounter-prevention-dialog/encounter-group-description/encounter-group-description.component';
import { WhiteButtonComponent } from '../ds-buttons/white-button/white-button.component';
import { WhiteRoundButtonComponent } from '../ds-buttons/white-round-button/white-round-button.component';
import { IconOnlyButtonComponent } from '../ds-buttons/icon-only-button/icon-only-button.component';
import { EditAvatarComponent } from '../admin/profile-card-dialog/edit-avatar/edit-avatar.component';
import { ProfilePictureComponent } from '../admin/accounts/profile-picture/profile-picture.component';
import { LinkGeneratedDialogComponent } from '../admin/link-generated-dialog/link-generated-dialog.component';
import { StatusChipComponent } from '../admin/explore/status-chip/status-chip.component';
import { ConfirmationDialogComponent } from './shared-components/confirmation-dialog/confirmation-dialog.component';
import { NuxUniversalComponent } from '../nux-components/nux-universal/nux-universal.component';
import { PassLimitFeedbackComponent } from '../pass-limit-feedback/pass-limit-feedback.component';
import { PassLimitInputComponent } from '../pass-limit-input/pass-limit-input.component';
import { ConfirmationComponent } from './shared-components/confirmation/confirmation.component';
import { PassLimitInfoComponent } from '../pass-limit-info/pass-limit-info.component';
import { IdNumbersComponent } from '../admin/accounts/id-numbers/id-numbers.component';
import { GradeLevelsComponent } from '../admin/accounts/grade-levels/grade-levels.component';
import { PassLimitBulkEditComponent } from '../pass-limit-bulk-edit/pass-limit-bulk-edit.component';
import { PassLimitStudentInfoComponent } from '../pass-limit-student-info/pass-limit-student-info.component';
import { AdminPassLimitDialogComponent } from '../admin-pass-limits-dialog/admin-pass-limits-dialog.component';
import { ConfirmDeleteKioskModeComponent } from '../request-card/confirm-delete-kiosk-mode/confirm-delete-kiosk-mode.component';
import { IdCardGradeLevelsComponent } from '../admin/id-cards/id-card-grade-levels/id-card-grade-levels.component';
import { IdCardIdNumbersComponent } from '../admin/id-cards/id-card-id-numbers/id-card-id-numbers.component';
import { ClassLinkComponent } from '../admin/accounts/class-link/class-link.component';
import { RoomCodeComponent } from '../room-code/room-code.component';
import { TeacherPinEndPassComponent } from '../teacher-pin-end-pass/teacher-pin-end-pass.component';
import { TeacherSelectionComponent } from '../teacher-selection/teacher-selection.component';
import { DateButtonComponent } from '../student-info-card/date-button/date-button.component';
import { OverviewContainerComponent } from '../student-info-card/student-passes-overwiew/overview-container.component';
import { SettingsComponent } from '../settings/settings.component';
import { InviteFamiliesDialogComponent } from '../admin/invite-families-dialog/invite-families-dialog.component';
import { InlineWaitInLineCardComponent } from '../pass-cards/inline-wait-in-line-card/inline-wait-in-line-card.component';
import { HelpCenterComponent } from './shared-components/help-center/help-center.component';
import { NuxHelpCenterComponent } from '../nux-components/nux-help-center/nux-help-center.component';
import { CallDialogComponent } from './shared-components/call-dialog/call-dialog.component';
import { TimeZoneService } from '../services/time-zone.service';
import { YearInReviewComponent } from '../admin/year-in-review/year-in-review.component';
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
	direction: 'horizontal',
	slidesPerView: 'auto',
};

@NgModule({
	imports: [CommonModule, ScrollingModule, FormsModule, ReactiveFormsModule, DragulaModule.forRoot(), SwiperModule, ChartsModule, CoreModule],
	declarations: [
		LoginComponent,
		SmartpassLogoComponent,
		DisplayCardComponent,
		PinnableComponent,
		TraveltypePickerComponent,
		SPSearchComponent,
		PassCollectionComponent,
		PassCellComponent,
		RestrictionDummyComponent,
		BackButtonComponent,
		PassCardComponent,
		TravelViewComponent,
		DurationPickerComponent,
		CardButtonComponent,
		PagerComponent,
		RoundInputComponent,
		AppInputComponent,
		CalendarComponent,
		SafariScrollDirective,
		ToggleInputComponent,
		CalendarPickerComponent,
		TimePickerComponent,
		AdminCalendarToggleComponent,
		ToggleOptionsComponent,
		SpChipsComponent,
		IconButtonComponent,
		CreatePassButtonComponent,
		IosCalendarWheelComponent,
		IosCalendarComponent,
		NavbarElementSenderDirective,
		ConsentMenuComponent,
		IntroDialogComponent,
		IntroComponent,
		SortMenuComponent,
		PrivacyCardComponent,
		ProfileComponent,
		AccountGroupsComponent,
		ReportSuccessToastComponent,
		RestrictionPickerComponent,
		SpAppearanceComponent,
		SpLanguageComponent,
		TeacherPinStudentComponent,
		TeacherPinEndPassComponent,
		RoomCodeComponent,
		MyProfileDialogComponent,
		ProfileInfoComponent,
		ChangePasswordComponent,
		CustomToolTipComponent,
		PassLimitTooltipComponent,
		BigStudentPassCardComponent,
		StudentMetricsComponent,
		InlinePassCardComponent,
		RequestCardComponent,
		InlineRequestCardComponent,
		InlineWaitInLineCardComponent,
		DropdownComponent,
		SettingsDescriptionPopupComponent,
		AppTextareaComponent,
		SquareButtonComponent,
		RoundButtonComponent,
		NuxEncounterPreventionComponent,
		SmartpassSearchComponent,
		EncounterGroupComponent,
		SelectRoleComponent,
		NuxTeacherViewComponent,
		DateTimeFilterComponent,
		ReportInfoDialogComponent,
		StatusPopupComponent,
		EncounterPreventionDialogComponent,
		CreateGroupComponent,
		ReportDescriptionComponent,
		EncounterOptionsComponent,
		EncounterGroupDescriptionComponent,
		WhiteButtonComponent,
		WhiteRoundButtonComponent,
		IconOnlyButtonComponent,
		EditAvatarComponent,
		ProfilePictureComponent,
		LinkGeneratedDialogComponent,
		StatusChipComponent,
		ConfirmationDialogComponent,
		NuxUniversalComponent,
		AdminPassLimitDialogComponent,
		PassLimitInfoComponent,
		PassLimitInputComponent,
		PassLimitFeedbackComponent,
		PassLimitBulkEditComponent,
		PassLimitStudentInfoComponent,
		ConfirmationComponent,
		IdNumbersComponent,
		GradeLevelsComponent,
		IdCardGradeLevelsComponent,
		IdCardIdNumbersComponent,
		ConfirmDeleteKioskModeComponent,
		ClassLinkComponent,
		TeacherSelectionComponent,
		DateButtonComponent,
		OverviewContainerComponent,
		SettingsComponent,
		InviteFamiliesDialogComponent,
		HelpCenterComponent,
		NuxHelpCenterComponent,
		CallDialogComponent,
		YearInReviewComponent,
	],
	exports: [
		ReactiveFormsModule,
		ScrollingModule,
		DragulaModule,
		SmartpassLogoComponent,
		DisplayCardComponent,
		PinnableComponent,
		TraveltypePickerComponent,
		SPSearchComponent,
		PassCollectionComponent,
		PassCellComponent,
		RestrictionDummyComponent,
		BackButtonComponent,
		TravelViewComponent,
		DurationPickerComponent,
		CardButtonComponent,
		PagerComponent,
		RoundInputComponent,
		AppInputComponent,
		PassCardComponent,
		CalendarComponent,
		SafariScrollDirective,
		ToggleInputComponent,
		CalendarPickerComponent,
		TimePickerComponent,
		AdminCalendarToggleComponent,
		ToggleOptionsComponent,
		SpChipsComponent,
		IconButtonComponent,
		CreatePassButtonComponent,
		IosCalendarWheelComponent,
		IosCalendarComponent,
		ChartsModule,
		SmartpassLogoComponent,
		IntroComponent,
		LoginComponent,
		CoreModule,
		PrivacyCardComponent,
		ProfileComponent,
		AccountGroupsComponent,
		ReportSuccessToastComponent,
		RestrictionPickerComponent,
		ProfileInfoComponent,
		ChangePasswordComponent,
		TeacherPinStudentComponent,
		TeacherPinEndPassComponent,
		RoomCodeComponent,
		PassLimitTooltipComponent,
		BigStudentPassCardComponent,
		StudentMetricsComponent,
		InlinePassCardComponent,
		RequestCardComponent,
		InlineRequestCardComponent,
		InlineWaitInLineCardComponent,
		DropdownComponent,
		AppTextareaComponent,
		SquareButtonComponent,
		RoundButtonComponent,
		CustomToolTipComponent,
		NuxEncounterPreventionComponent,
		SmartpassSearchComponent,
		EncounterGroupComponent,
		SelectRoleComponent,
		NuxTeacherViewComponent,
		DateTimeFilterComponent,
		ReportInfoDialogComponent,
		StatusPopupComponent,
		EncounterPreventionDialogComponent,
		CreateGroupComponent,
		ReportDescriptionComponent,
		EncounterOptionsComponent,
		EncounterGroupDescriptionComponent,
		WhiteButtonComponent,
		WhiteRoundButtonComponent,
		IconOnlyButtonComponent,
		EditAvatarComponent,
		ProfilePictureComponent,
		LinkGeneratedDialogComponent,
		StatusChipComponent,
		NuxUniversalComponent,
		AdminPassLimitDialogComponent,
		PassLimitInfoComponent,
		PassLimitInputComponent,
		PassLimitFeedbackComponent,
		PassLimitBulkEditComponent,
		PassLimitStudentInfoComponent,
		IdNumbersComponent,
		GradeLevelsComponent,
		IdCardGradeLevelsComponent,
		IdCardIdNumbersComponent,
		ConfirmDeleteKioskModeComponent,
		ClassLinkComponent,
		TeacherSelectionComponent,
		DateButtonComponent,
		OverviewContainerComponent,
		SettingsComponent,
		InviteFamiliesDialogComponent,
		HelpCenterComponent,
		NuxHelpCenterComponent,
		CallDialogComponent,
		YearInReviewComponent,
	],
	providers: [
		{
			provide: SWIPER_CONFIG,
			useValue: DEFAULT_SWIPER_CONFIG,
		},
		{ provide: 'TimeZoneService', useClass: TimeZoneService },
		GettingStartedProgressService,
	],
})
export class SharedModule {}
